export const PWA_INSTALL_DISMISSAL_KEY = 'nrw.pwa-install.dismissed-at'
export const PWA_INSTALL_DISMISSAL_MS = 14 * 24 * 60 * 60 * 1000

export function detectPwaPlatform(navigatorLike = {}) {
  const userAgent = navigatorLike.userAgent ?? ''
  if (/Android/i.test(userAgent)) return 'android'

  const iOSUserAgent = /iPad|iPhone|iPod/i.test(userAgent)
  const iPadDesktopMode = navigatorLike.platform === 'MacIntel' && Number(navigatorLike.maxTouchPoints) > 1
  if (iOSUserAgent || iPadDesktopMode) return 'ios'

  return 'other'
}

export function isStandaloneDisplay(windowLike = {}, navigatorLike = {}) {
  return Boolean(windowLike.matchMedia?.('(display-mode: standalone)').matches || navigatorLike.standalone === true)
}

export function shouldShowInstallHelper({ platform, dismissed, standalone }) {
  return !dismissed && !standalone && (platform === 'android' || platform === 'ios')
}

export function isInstallDismissalActive(value, now = Date.now()) {
  const dismissedAt = Number(value)
  return Number.isFinite(dismissedAt) && dismissedAt > 0 && now - dismissedAt < PWA_INSTALL_DISMISSAL_MS
}

export function readInstallDismissal(storage, now = Date.now()) {
  try {
    return isInstallDismissalActive(storage?.getItem(PWA_INSTALL_DISMISSAL_KEY), now)
  } catch {
    return false
  }
}

export function writeInstallDismissal(storage, now = Date.now()) {
  try {
    storage?.setItem(PWA_INSTALL_DISMISSAL_KEY, String(now))
  } catch {
    // The helper remains dismissible for the current page when storage is unavailable.
  }
}
